import { configureStore } from '@reduxjs/toolkit';
import { ActionTypes, Article, Collection, Media, RootStore } from './types'

const initialState: RootStore = {
  appName: "Big Little Idea",
  byline: "",
  organizations: [],
  collections: [],
  articles: [],
  media: [],
  loggedInUser: null,
  showUnpublishedArticles: false,
  showUnpublishedCollections: false,
};

export function articlesReducer(state = initialState, action) {
  switch (action.type) {

    case ActionTypes.SET_APP_NAME:
      return Object.assign({}, state, {
        appName: action.payload
      });

    case ActionTypes.UPDATE_COLLECTIONS: {
      const collectionIdSet = new Set<number>();
      const updatedCollections = action.payload as Array<Collection>;
      updatedCollections.forEach( (collection:Collection) => {
        collectionIdSet.add(collection.ID);
      });
      const oldState = state.collections.filter((c: Collection) => !collectionIdSet.has(c.ID));
      return Object.assign({}, state, { collections: oldState.concat(updatedCollections) });
    }

    case ActionTypes.SET_LOGGED_IN_USER: {
      return Object.assign({}, state, { loggedInUser: action.payload });
    }

    case ActionTypes.UPDATE_ARTICLES: {
      const articleIdSet = new Set<number>();
      const updatedArticles = action.payload as Array<Article>;
      updatedArticles.forEach((article: Article) => {
        articleIdSet.add(article.ID);
      });
      const oldState = state.articles.filter((a: Article) => !articleIdSet.has(a.ID));
      return Object.assign({}, state, { articles: oldState.concat(updatedArticles) });
    }

    case ActionTypes.SET_SHOW_UNPUBLISHED_ARTICLES: {
      return Object.assign({}, state, { showUnpublishedArticles: action.payload });
    }

    case ActionTypes.SET_SHOW_UNPUBLISHED_COLLECTIONS: {
      return Object.assign({}, state, { showUnpublishedCollections: action.payload });
    }

    case ActionTypes.UPDATE_MEDIA: {
      const mediaIdSet = new Set<number>();
      const updatedMedia = action.payload as Array<Media>;
      updatedMedia.forEach((media: Media) => {
        mediaIdSet.add(media.ID);
      });
      const oldState = state.media.filter((m: Media) => !mediaIdSet.has(m.ID));
      return Object.assign({}, state, { media: oldState.concat(updatedMedia) });
    }

    default:
      return state
  }
}

const store = configureStore({
  reducer: articlesReducer,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export default store;
